import has from 'lodash.has';
var CryptoJS = require('crypto-js');

export function featuredImage(post, imageSize = "full") {
    if (post && has(post, '_embedded.wp:featuredmedia')) {
        for (let featuredMediaItem of post._embedded["wp:featuredmedia"]) {
            if (featuredMediaItem.media_type === 'image') {

                if (imageSize in featuredMediaItem.media_details.sizes) {
                    return featuredMediaItem.media_details.sizes[imageSize].source_url;
                }

            }
        }
    }
}

export function featuredImageWithFallback(post, imageSize = "full") {
    let featuredImagePath = featuredImage(post, imageSize);

    if (!featuredImagePath) {
        featuredImagePath = randomImage(600,600);
    }

    return featuredImagePath;
}

export function imageWithFallback(imageObject, imageSize = "full") {
    if (imageSize in imageObject.sizes) {
        return imageObject.sizes[imageSize];
    }
}

export function employeeRoles(employee) {
    let employeeRoles = [];

    if (employee && has(employee, '_embedded.wp:term')) {
        for (let termGroup of employee._embedded["wp:term"]) {

            for (let term of termGroup) {
                if (term.taxonomy === 'employeefunctions') {
                    employeeRoles.push(term.name);
                } else {
                    break;
                }
            }

        }
    }

    return employeeRoles;
}

export function projectCategories(employee) {
    let projectCategories = [];

    if (employee && has(employee, '_embedded.wp:term')) {
        for (let termGroup of employee._embedded["wp:term"]) {

            for (let term of termGroup) {
                if (term.taxonomy === 'projectcategories') {
                    projectCategories.push(term.name);
                } else {
                    break;
                }
            }

        }
    }

    return projectCategories;
}

export function newsCategories(newsItem) {
    let newsCategories = [];

    if (newsItem && has(newsItem, '_embedded.wp:term')) {
        for (let termGroup of newsItem._embedded["wp:term"]) {

            for (let term of termGroup) {
                if (term.taxonomy === 'category') {
                    newsCategories.push(term.name);
                } else {
                    break;
                }
            }

        }
    }

    return newsCategories;
}

export function hasCategory(item, category) {
    if (has(item, 'projectcategories') && has(category, 'id')) {
        var elements = item.projectcategories.find((element) => {
            if (element === category.id) {
                return true;
            } else {
                return false;
            }
        }, category);

        if (elements) {
            return true;
        }
    }

    return false;
}

export function randomImage(min, max) {
    const randomImageWidth = Math.floor(Math.random() * (max - min) + min);
    return `http://pipsum.com/${randomImageWidth}x${randomImageWidth}.jpg`;
}

function gravityFormsSignature(settings, method, route, expirationTime) {

    const stringToSign = `${settings.publicKey}:${method}:${route}:${expirationTime}`;

    const hash = CryptoJS.HmacSHA1(stringToSign, settings.privateKey);
    const base64 = hash.toString(CryptoJS.enc.Base64);

    return encodeURIComponent(base64);
}


function gravityFormsURL(settings, method, route, expirationTime) {
    const signature = gravityFormsSignature(settings, method, route, expirationTime);
    return `${settings.domain}/gravityformsapi/${route}/?api_key=${settings.publicKey}&signature=${signature}&expires=${expirationTime}`;
}

export function gravityFormsRequest(settings, method, route, data = {}) {
    let d = new Date();
    let expiration = 3600; // 1 hour,
    // eslint-disable-next-line
    let unixtime = parseInt(d.getTime() / 1000);
    const expirationTime = unixtime + expiration;

    const url = gravityFormsURL(settings, method, route, expirationTime);

    const fetchProperties = {
        method: method,
        body: JSON.stringify(data)
    };

    return fetch(url, fetchProperties);
    
    
}


// WEBPACK FOOTER //
// ./src/utilities.js